module.exports = "/src/views/player/help/images/fib.jpg";